var ReviewModals = {
  data: {
    selectors: {
    },
  },

  

  onReady: function() {
    const parsedUrl = new URL(window.location.href);
    const modal = parsedUrl.searchParams.get("id");

    if (modal === null) {
      return;
    }

    window.addEventListener('load', (event) => {

      document.getElementById(modal).classList.add('show');
      document.getElementById(modal).style.display = "block";
      document.getElementById(modal).setAttribute("aria-hidden", "true");
      document.body.insertAdjacentHTML("afterBegin", "<div id='modalBackdrop' class='modal-backdrop fade show'></div>")

      document.querySelector("body").classList.add('modal-open');
      document.querySelector("body").style.overflow = "hidden";
      document.querySelector("body").style.padding = "0px";

    });

    document.getElementById('reviewButtonClose').addEventListener("click", () => {
      document.getElementById(modal).classList.remove('show');
      document.getElementById(modal).style.display = "none"
      document.getElementById(modal).setAttribute("aria-hidden", "true");

      document.getElementById('modalBackdrop').classList.remove('show');

      document.getElementById('modalBackdrop').addEventListener("transitionend", () => 
      {
        document.getElementById('modalBackdrop').remove();
      })
      

      document.querySelector("body").classList.remove('modal-open');
      document.querySelector("body").style.overflow = "";
      document.querySelector("body").style.padding = "";

      
    })

    document.querySelector("body").addEventListener("click", (e) => {
      if(e.target.classList.contains('show')) {
        document.getElementById(modal).classList.remove('show');
        document.getElementById(modal).style.display = "none"
        document.getElementById(modal).setAttribute("aria-hidden", "true");
        
        document.getElementById('modalBackdrop').classList.remove('show');

        document.getElementById('modalBackdrop').addEventListener("transitionend", () => 
        {
          document.getElementById('modalBackdrop').remove();
        })

        document.querySelector("body").classList.remove('modal-open');
        document.querySelector("body").style.overflow = "";
        document.querySelector("body").style.padding = "";


      }
    })
  }
};

module.exports = ReviewModals;